module.exports = __webpack_public_path__ + "img/804.665115fa.gif";